import { render } from "./운전면허.vue?vue&type=template&id=b0af9de8"
import script from "./운전면허.vue?vue&type=script&lang=js"
export * from "./운전면허.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__